import { Injectable } from '@angular/core';
import { distinctUntilChanged, fromEvent, map, Observable, startWith } from 'rxjs';
import { BOOTSTRAP_BREAKPOINTS, Region } from '../../enums/responsive.enum';

@Injectable({ providedIn: 'root' })
export class UiResponsiveService {
    public currentScreenSize$: Observable<number>;
    public currentRegion$: Observable<Region>;
    public isMobile$: Observable<boolean>;
    public constructor() {
        this.currentScreenSize$ = fromEvent(window, 'resize').pipe(
            startWith(window.innerWidth),
            map(() => window.innerWidth),
            distinctUntilChanged(),
        );

        // Mapping screen size to region
        this.currentRegion$ = this.currentScreenSize$.pipe(map((windowWidth) => this.getRegion(windowWidth)));

        // Detect when we move into mobile region: Below the lg breakpoint 992px
        this.isMobile$ = this.currentRegion$.pipe(
            map((region) => [Region.Unknown, Region.SmallRegion, Region.MediumRegion].includes(region)),
        );
    }

    public getRegion(windowWidth: number): Region {
        if (windowWidth >= BOOTSTRAP_BREAKPOINTS.SM && windowWidth < BOOTSTRAP_BREAKPOINTS.MD) {
            return Region.SmallRegion;
        } else if (windowWidth >= BOOTSTRAP_BREAKPOINTS.MD && windowWidth < BOOTSTRAP_BREAKPOINTS.LG) {
            return Region.MediumRegion;
        } else if (windowWidth >= BOOTSTRAP_BREAKPOINTS.LG && windowWidth < BOOTSTRAP_BREAKPOINTS.XL) {
            return Region.LargeRegion;
        } else if (windowWidth >= BOOTSTRAP_BREAKPOINTS.XL && windowWidth < BOOTSTRAP_BREAKPOINTS.XXL) {
            return Region.DesktopRegion;
        } else if (windowWidth >= BOOTSTRAP_BREAKPOINTS.XXL) {
            return Region.LargeDesktopRegion;
        }
        return Region.Unknown;
    }
}
